import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCondo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M29.994 32V.66a.678.678 0 0 0-.827-.643L2.531 6.794a.678.678 0 0 0-.525.647v24.545h9.643v-9.91h8.702V32zm-6.94-22.292h3.29v3.29h-3.29zm0 5.807h3.29v3.29h-3.29zm-5.797-5.807h3.29v3.29h-3.29zm-8.312 9.104H5.66v-3.29h3.29zm0-5.808H5.66V9.709h3.29zm5.798 5.808h-3.29v-3.29h3.29zm0-5.808h-3.29V9.709h3.29zm2.514 5.808v-3.29h3.29v3.29z" /></svg>;
export default SvgCondo;